import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// ── English namespaces ──────────────────────────────────────────────────────
import enCommon from '@/locales/en/common.json';
import enNavigation from '@/locales/en/navigation.json';
import enKpi from '@/locales/en/kpi.json';
import enCharts from '@/locales/en/charts.json';
import enFilters from '@/locales/en/filters.json';
import enAuth from '@/locales/en/auth.json';
import enSurvey from '@/locales/en/survey.json';
import enInsights from '@/locales/en/insights.json';
import enMetricDefinitions from '@/locales/en/metric_definitions.json';
import enErrors from '@/locales/en/errors.json';
import enLanding from '@/locales/en/landing.json';
import enExport from '@/locales/en/export.json';

// ── French namespaces ───────────────────────────────────────────────────────
import frCommon from '@/locales/fr/common.json';
import frNavigation from '@/locales/fr/navigation.json';
import frKpi from '@/locales/fr/kpi.json';
import frCharts from '@/locales/fr/charts.json';
import frFilters from '@/locales/fr/filters.json';
import frAuth from '@/locales/fr/auth.json';
import frSurvey from '@/locales/fr/survey.json';
import frInsights from '@/locales/fr/insights.json';
import frMetricDefinitions from '@/locales/fr/metric_definitions.json';
import frErrors from '@/locales/fr/errors.json';
import frLanding from '@/locales/fr/landing.json';
import frExport from '@/locales/fr/export.json';

const LANG_KEY = 'brandedge_language';
const saved = typeof window !== 'undefined' ? localStorage.getItem(LANG_KEY) : null;
const initLng = saved === 'fr' ? 'fr' : 'en';

i18n
  .use(initReactI18next)
  .init({
    lng: initLng,
    resources: {
      en: {
        common: enCommon,
        navigation: enNavigation,
        kpi: enKpi,
        charts: enCharts,
        filters: enFilters,
        auth: enAuth,
        survey: enSurvey,
        insights: enInsights,
        metric_definitions: enMetricDefinitions,
        errors: enErrors,
        landing: enLanding,
        export: enExport,
      },
      fr: {
        common: frCommon,
        navigation: frNavigation,
        kpi: frKpi,
        charts: frCharts,
        filters: frFilters,
        auth: frAuth,
        survey: frSurvey,
        insights: frInsights,
        metric_definitions: frMetricDefinitions,
        errors: frErrors,
        landing: frLanding,
        export: frExport,
      },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
